<template>
  <nav
    id="sidebar"
    class="sidebar"
    :class="{ collapsed: collapsed }"
  >
    <div>
      <router-link
        to="/"
        class="sidebar-brand"
        tag="a"
      >
        <img
          src="../assets/images/logo.png"
          style="max-width: 290px; max-height: 50px"
        />
      </router-link>
      <ul class="sidebar-nav">
        <template v-for="section in menu">
          <li
            v-if="section.name"
            class="sidebar-header"
          >
            {{ $t(`gpool.menu_${section.name}`) }}
          </li>

          <template v-if="section.hasOwnProperty('items')">
            <li
              class="sidebar-item"
              :class="{ active: $route.path === item.path }"
              v-for="item in section.items"
            >
              <a
                v-if="item.hasOwnProperty('external')"
                :href="item.external"
                target="_blank"
                class="sidebar-link"
              >
                <i :class="`fa fa-${item.icon} fa-fw`"></i>
                <span class="align-middle">
                  {{ $t(`gpool.menu_${item.name}`) }}
                </span>
              </a>
              <router-link
                v-else
                class="sidebar-link"
                :to="item.path"
                @click.native="toggle"
              >
                <i :class="`fa fa-${item.icon} fa-fw`"></i>
                <span class="align-middle">
                  {{ $t(`gpool.menu_${item.name}`) }}
                </span>
              </router-link>
            </li>
          </template>
        </template>
        <!-- <li class="sidebar-item">
          <a
            data-bs-target="#maps"
            data-bs-toggle="collapse"
            class="sidebar-link collapsed"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-map-pin align-middle"
            >
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle
                cx="12"
                cy="10"
                r="3"
              ></circle>
            </svg>
            <span class="align-middle">Maps</span>
          </a>
          <ul
            id="maps"
            class="sidebar-dropdown list-unstyled collapse"
            data-bs-parent="#sidebar"
          >
            <li class="sidebar-item">
              <a
                class="sidebar-link"
                href="maps-google.html"
                >Google Maps</a
              >
            </li>
            <li class="sidebar-item">
              <a
                class="sidebar-link"
                href="maps-vector.html"
                >Vector Maps</a
              >
            </li>
          </ul>
        </li> -->
        <!-- <li class="sidebar-header">Pages</li> -->
      </ul>
    </div>
  </nav>
</template>
<script>
import { mapActions, mapState } from "vuex";
import menu from "@/data/menu";
export default {
  name: "Sidebar",
  computed: {
    isMobile() {
      return this.$device.mobile;
    },
    ...mapState(["collapsed"])
  },
  methods: {
    toggle() {
      if (this.isMobile) this.toggleSidebar();
    },
    ...mapActions(["toggleSidebar"])
  },
  data() {
    return {
      menu
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Sidebar.vue